import { $themeConfig } from "@themeConfig";
import app from "@/main";
import useJwt from "@/auth/jwt/useJwt";

export default {
  namespaced: true,
  state: {
    totalNotifications: 0,
    notifications: [],
  },
  getters: {
    notifications(state) {
      return state.notifications;
    },
  },
  mutations: {
    SET_SHOWS_BY_ID(state, payload) {
      state.notifications = state.notifications.filter((notification) => {
        if (notification.id == payload.id) {
          notification.shown = payload.value;
          return notification;
        } else {
          notification.shown = false;

          return notification;
        }
      });
    },
    SET_SHOWS_PAGE_BY_ID(state, payload) {
      state.notifications = state.notifications.filter((notification) => {
        if (notification.id == payload.id) {
          notification.shownPage = payload.value;
          return notification;
        } else {
          notification.shownPage = false;

          return notification;
        }
      });
    },
    SET_NOTIFICATION(state, payload) {
      state.totalNotifications = payload || 0;
    },
    SET_HIDE_BY_ID(state, id) {
      state.notifications = state.notifications.filter((notification) => {
        if (notification.id == id) {
          notification.shown = false;
          return notification;
        } else {
          return notification;
        }
      });
    },
    
    SET_NOTIFY_BY_USER(state, payload) {
      state.notifications = payload.map((notification) => {
        notification.shown = false;
        return notification;
      });
    },
    SET_NOTIFY_BY_USER_PUSH(state, payload) {
      state.notifications.push(...payload);
    },
    SET_UPDATE_READ_BY_ID(state, id) {
      state.notifications = state.notifications.filter((notification) => {
        notification.shown = false;
        if (notification.id == id) {
          notification.readed = 1;
          return notification;
        } else {
          return notification;
        }
      });
    },
    RESET(state) {
      state.notifications = [];
    },
  },
  actions: {
    GET_NOTIFICATION({ commit }, payload) {
      useJwt.get("totalUserNotify").then((response) => {
        if (response.data && response.data.message == "Query success!") {
          commit("SET_NOTIFICATION", response.data.result[0].total_notify);
        }
      });
    },
    GET_NOTIFY_BY_USER({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .get("userNotify", {
            params: {
              search: payload.search,
              page: payload.page,
              pageSize: payload.pageSize,
              readed: payload.readed,
            },
          })
          .then((response) => {
            payload.pagination
              ? commit("SET_NOTIFY_BY_USER_PUSH", response.data.result)
              : commit("SET_NOTIFY_BY_USER", response.data.result);
            resolve(response.data);
          });
      });
    },
    UPDATE_NOTIFY({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .put("userNotify", {
            ids: payload.ids,
            markAllAsRead: payload.markAllAsRead,
          })
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    UNREAD_NOTIFY({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .put("userNotify", {
            ids: payload.ids,
            markAsUnRead: payload.markAsUnRead,
          })
          .then((response) => {
            resolve(response.data);
          });
      });
    },
    DELETE_NOTIFY({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt.delete("userNotify?ids=" + payload.id).then((response) => {
          resolve(response.data);
        });
      });
    },
  },
};
